import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ArrowLeft } from 'lucide-react'

const sectionKeys = [
  'general',
  'scopeServiceAmendments',
  'usageRights',
  'registration',
  'prices',
  'availability',
  'liability',
  'durationTermination',
  'copyright',
  'finalProvisions'
]

const TermsandCondition = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const terms = t('termsAndConditions', { returnObjects: true })

   const handleBackToDashboard = () => {
    // navigate('/dashboard')
    if (window.history.length > 2) {
      navigate(-1)
    } else {
      navigate('/dashboard')
    }
  }

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <div className="border-b border-gray-800">
        <div className="max-w-6xl mx-auto px-2 sm:px-4 lg:px-6 py-4">
          <button
            onClick={handleBackToDashboard}
            className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors duration-200"
          >
            <ArrowLeft className="w-5 h-5" />
            {/* <span className="text-sm font-medium">{t('backtoDashboard')}</span> */}
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-6xl mx-auto px-2 sm:px-4 lg:px-6 py-8 lg:py-12">
        <div className="mb-12">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-8 tracking-wide">
            {terms.title}
          </h1>
        </div>

        {/* Sections */}
        <div className="space-y-8">
          {sectionKeys.map((sectionKey, idx) => {
            const section = terms[sectionKey]
            if (!section) return null

            return (
              <div key={sectionKey} className="mb-8">
                <h2 className="text-lg sm:text-xl lg:text-2xl font-bold text-white mb-6">
                  {section.heading}
                </h2>

                <div className="space-y-4">
                  {Object.entries(section)
                    .filter(([k]) => k.startsWith('point'))
                    .map(([pointKey, pointValue], pointIdx) => (
                      <div key={pointKey} className="flex gap-3 items-start">
                        <span className="text-white font-medium text-sm sm:text-base flex-shrink-0 mt-0.5">
                          {pointIdx + 1}.
                        </span>
                        <p className="text-gray-200 text-sm sm:text-base leading-relaxed">
                          {pointValue}
                        </p>
                      </div>
                    ))}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default TermsandCondition